export const SET_PRODUCTS = 'SET_PRODUCTS';
export const PRODUCTS_LOADING = 'PRODUCTS_LOADING';
export const PRODUCTS_ERROR = 'PRODUCTS_ERROR';
export const PRODUCTS_NOT_FOUND = 'PRODUCTS_NOT_FOUND';
export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';
